import { render, staticRenderFns } from "./InputImgUploader.vue?vue&type=template&id=2ff2cc10&scoped=true"
import script from "./InputImgUploader.vue?vue&type=script&lang=js"
export * from "./InputImgUploader.vue?vue&type=script&lang=js"
import style0 from "./InputImgUploader.vue?vue&type=style&index=0&id=2ff2cc10&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff2cc10",
  null
  
)

export default component.exports